import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["report"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { useMemo } from 'react';

// @ts-expect-error Untyped dependency
import ActionButton from '../ActionButton';
// @ts-expect-error Untyped dependency
import { encodeReport } from '../../reportingActions/editReport/openReportInBuilder';
import UIIcon from 'UIComponents/icon/UIIcon';
import http from 'hub-http/clients/apiClient';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const REPORTING_SANDBOX_LINK_SHORTENER = 'reporting-sandbox/v1/reporting-sandbox-object';
const CLOUDFLARE_ESTIMATED_URL_LIMIT = 14000;
export const generateSandboxShortenedLink = (partialSandboxLink, report) => http.post(REPORTING_SANDBOX_LINK_SHORTENER, {
  data: {
    reportingSandboxObjectJson: report
  }
}).then(({
  id
}) => `${partialSandboxLink}?linkId=${id}`);
export const ViewInSandboxButton = _ref => {
  let {
      report
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const portalId = PortalIdParser.get();
  const partialSandboxLink = `/reporting-sandbox/${portalId}/build/playground`;
  const encodedReport = useMemo(() => {
    return encodeReport(report);
  }, [report]);
  const encodedSandboxLink = `${partialSandboxLink}?encoded=${encodedReport}`;
  const onClickViewInSandbox = () => {
    if (encodedReport && encodedReport.length > CLOUDFLARE_ESTIMATED_URL_LIMIT) {
      generateSandboxShortenedLink(partialSandboxLink, report).then(shortenedLink => {
        window.open(shortenedLink);
      }).catch(() => {
        window.open(encodedSandboxLink);
      });
    } else {
      window.open(encodedSandboxLink);
    }
  };
  try {
    if (JSON.parse(localStorage.getItem('sandbox-link') || '') === true) {
      return /*#__PURE__*/_jsx(ActionButton, Object.assign({
        "data-test-id": "report-action-view-in-sandbox",
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.viewInSandbox.button.text"
          }), /*#__PURE__*/_jsx(UIIcon, {
            name: "externalLink"
          })]
        }),
        onClick: onClickViewInSandbox
      }, buttonProps));
    }
    return null;
  } catch (err) {
    console.warn(`storage: failed to get 'sandbox-link' from localStorage`);
    return null;
  }
};
export default ViewInSandboxButton;